"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
/** @module converter */
__export(require("./ascii"));
__export(require("./trits"));
//# sourceMappingURL=index.js.map